/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { IconEdit } from "@tabler/icons-react";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useUpdateImage } from "cms/rich-text/simplicity-composer-tiptap/image/use-update-image";
import Button from "@mui/material/Button";
import { useCurrentEditor } from "@tiptap/react";

export const ImageToolTipDisplay = (props) => {
    
    const {
        // visible,
        setVisible,
    } = props;
    
    const { t } = useTranslation();
    const { image } = useUpdateImage();
    const { editor } = useCurrentEditor();
    
    
    useEffect(() => {
        const guid = image?.guid;
        if (guid === null) {
            setVisible(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [image]);
    
    const onOpenImageEditor = () => {
        setVisible(true);
    };
    const onRemoveImage = () => {
        editor.commands.deleteSelection();
        editor.commands.setNode("paragraph", {});
    };
    
    return (
        <div className="simplicity-richtext-composer-editor-tooltip">
            {image?.title}
            <div className='simplicity-richtext-composer-editor-tooltip-buttons'>
                <div>
                    <Button variant='text'
                        onClick={onOpenImageEditor}
                        startIcon={<IconEdit/>}
                    >
                        {t("Editor.edit")}
                    </Button>
                </div>
                <div>
                    <Button variant='text'
                        onClick={onRemoveImage}
                        // startIcon={<IconX/>}
                    >
                        {t("Editor.remove")}
                    </Button>
                </div>
            </div>
        </div>
    );
};
